<template>
  <div class="product">
    <banner img="p_bg2.jpg" title="产品中心" />
    <div class="product-content" v-loading="loading">
      <div class="p-video">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
      <div class="lacking">
        <h3 class="title">技术持有</h3>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/product-icon_1.png" alt="禁毒及司法鉴定领域分析仪器的研发与生产" />
            </div>
            <p>禁毒及司法鉴定领域分析仪器的研发与生产</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/product-icon_2.png" alt="海洋生物检验设备及在线监控系统设施的研发生产" />
            </div>
            <p>海洋生物检验设备及在线监控系统设施的研发生产</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/product-icon_3.png" alt="流行病在线预警系统的研发与应用" />
            </div>
            <p>流行病在线预警系统的研发与应用</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/product-icon_4.png" alt="应用于社会生活中的快速检测设备的研发与生产" />
            </div>
            <p>应用于社会生活中的快速检测设备的研发与生产</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/product-icon_5.png" alt="环境快速检测设备的研发与生产" />
            </div>
            <p>环境快速检测设备的研发与生产</p>
          </div>
        </div>
      </div>
      <!-- 文档下载 -->
      <div >
        <h3 class="title">文件下载</h3>
        <div class="space_content downLoad" style="text-indent:0rem;margin:2rem 0 4rem 1rem;">
            <p class="link"><a  class="a" href="/A.pdf" download="历思水质采样机(WS2000) 型-产品说明书">历思水质采样机(WS2000) 型-产品说明书.pdf</a></p>
        </div>
    
      </div>
      <!--功能模块  -->
      <div class="modular">
        <h3 class="title">产品状况</h3>
        <p class="eTitle">STATUS</p>
        <div class="modular-content">
          <div class="modular-content-same">
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_1.png" alt="质谱毒检仪" />
              </div>
              <p class="p">质谱毒检仪</p>
            </div>
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_2.png" alt="污水采样器" />
              </div>
              <p class="p">污水采样器</p>
            </div>
            <!-- <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_3.png" alt />
              </div>
              <p class="p">物证箱</p>
            </div>
            <div class="same-item">
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_1.png" alt />
              </div>
              <p class="p">定位复核模块</p>
            </div> -->
          </div>
          <div class="modular-content-center">
            <img src="../assets/img/product_group_4_img.png" alt="product_group_4_img" />
          </div>
          <div class="modular-content-same">
            <div class="same-item">
              <p class="p">物证箱</p>
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_5.png" alt="product-group_4-icon" />
              </div>
            </div>
            <!-- <div class="same-item">
              <p class="p">材料设备模块</p>
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_6.png" alt />
              </div>
            </div>
            <div class="same-item">
              <p class="p">进度控制模块</p>
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_7.png" alt />
              </div>
            </div>
            <div class="same-item">
              <p class="p">安全管理模块</p>
              <div class="same-item-img">
                <img src="../assets/img/product-group_4-icon_8.png" alt />
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      loading: false,
      videoSrc: require("../assets/CYQ.mp4"),
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: require("../assets/CYQ.mp4")//url地址
          }
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  components: {
    Banner
  },
  created() {
    // this.$http
    //   .get(
    //     "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
    //   )
    //   .then(response => {
    //     this.videoSrc = response.data[0].Content;
    //     window.console.log(this.videoSrc);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.p-video {
  transition:all .1s;
  width: 1000px;
  margin: 0 auto;
  padding: 60px 0;
}

@media screen and (max-width: 1140px){
  .p-video{
    width:750px;
  }
  .product-content{
    width:auto;
  }
  .target-img .img{
    width:750px!important;
  }
}
@media screen and (max-width: 937px){
  .p-video{
    width:445px;
  }
  .lacking .lacking-bottom{
    padding:0!important;
    flex-wrap: wrap;
  }
  .modular-content-center{
    width:0!important;
        height:0!important;
  }
  .lacking .lacking-bottom .lacking-bottom-item .lacking-bottom-item-img{
    width:100px!important;
    height:100px!important;
    line-height:136px!important;
    
  }
  .lacking-bottom-item-img img{
    width:50px
  }
  .target-img .img{
    width:450px!important;
  }
}
@media screen and(max-width:482px){
  .target-img .img{
    width:420px!important;
  }
  .lacking .lacking-bottom .lacking-bottom-item .lacking-bottom-item-img{
    img{
      width:75px!important;
      height:75px!important;
    }
    width: 73px !important;
    height: 74px !important;
    line-height: 100px !important;
    
  }
  .lacking-bottom-item-img img{
    width:35px;
  }
  .modular-content-same {
    .same-item {
      .same-item-img{
        // display:none;
        width:0!important;
        height:0!important;
      }
      height:auto!important;
      justify-content: center!important;
    }
    .p{
      width: 102px;
      line-height:20px!important;
    }
  }
}

//传统管理模式不足
.lacking {
  // height: 420px;
  padding: 20px 0;
  //margin: 20px 0;

  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    padding: 100px 100px;
    padding-bottom: 0;
    .lacking-bottom-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 0 20px;
      //justify-content: center;

      .lacking-bottom-item-img {
        // width: 120px;
        // height: 120px;
        background: #1667a0;
        border-radius: 50%;
        overflow: hidden;
        // line-height: 160px;
        transition:all .3s;
        margin: 16px 0;
        padding:20px;
        img{
          width: 100px;
          height: 100px;
        }
      }
    }
    .p {
      font-size: 16px;
      text-align: start;
      margin: 10px 0;
      
    }
  }
}

//平台目标
.target {
  margin-top: 50px;
  &-img {
    margin-top: 50px;
    text-align: center;
  }
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
      transition: all .2s;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
  transition:all .3s;
}
.downLoad{
  padding: 50px 50px;
    display: flex;
    justify-content: space-around;
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 30px;
  padding: 10px 0;
}
.target-img .img{
  transition:all 0.3s;
  width:auto;
}
@media screen and (max-width: 445px){
  .p-video /deep/.vjs-custom-skin > .video-js .vjs-control-bar .vjs-playback-rate{
    width: 1.5em!important;
  }
  .p-video{
    width:300px;
  }
  .target-img .img{
    width:300px!important;
  }
}
.link{
line-height: 2rem;
}
.a{
  color:#000;
}
.a:hover{
  color:blue;
}
</style>